import React, { useState } from "react";
import { ChevronLeft, ChevronRight } from "lucide-react";
import Home2 from "./Home2";
import Home3 from './Home3';
import Home4 from './Home4';
import Home5 from "./Home5";

const Home = () => {
  const [currentSlide, setCurrentSlide] = useState(0);
  const totalSlides = 3;

  const images = [
    "https://i0.wp.com/plumvillage.org/wp-content/uploads/2024/08/NH-WK-15Aug2024.2.jpg?fit=654%2C436&ssl=1",
    "https://i0.wp.com/plumvillage.org/wp-content/uploads/2024/08/455087769_559807166706966_9030153037715043508_n.jpg?fit=654%2C436&ssl=1",
    "https://i0.wp.com/plumvillage.org/wp-content/uploads/2024/08/NH-22th-July-202400004.jpg?fit=654%2C427&ssl=1",
  ];

  const nextSlide = () => {
    setCurrentSlide((prev) => (prev + 1) % totalSlides);
  };

  const prevSlide = () => {
    setCurrentSlide((prev) => (prev - 1 + totalSlides) % totalSlides);
  };

  return (
    <div className=" bg-white">
      <main className=" mx-auto ">
        <div className="flex flex-col lg:flex-row">
          <div className="lg:w-1/2 lg:pr-8 px-18 pt-8 flex flex-col justify-center gap-8 mx-auto ">
            <img
              src="https://i0.wp.com/plumvillage.org/wp-content/uploads/2019/07/plumvillage-black.png?fit=646%2C166&ssl=1" // Bạn cần thay thế bằng đường dẫn logo chính xác
              alt="Plum Village Logo"
              className="w-[300px]"
            />
            <p className="text-3xl text-gray-600 mb-8 font-extralight ">
              A global community of mindfulness practice centres offering
              <span className="border-b-2 border-yellow-300">retreats</span>
              and teachings on engaged Buddhism and
              <span className="border-b-2 border-yellow-300">
                the art of mindful living
              </span>
              , founded by Zen Master
              <span className="border-b-2 border-yellow-300">
                Thich Nhat Hanh.
              </span>
            </p>
          </div>
          <div className="lg:w-1/2 h-[600px] relative">
            <img
              src={images[currentSlide % images.length]}
              alt={`Slide ${currentSlide + 1}`}
              className="w-full h-[600px] object-cover"
            />
            <div className="absolute bottom-4 left-14 transform -translate-x-1/2 flex space-x-2">
              {[...Array(totalSlides)].map((_, i) => (
                <div
                  key={i}
                  className={`w-2 h-2 rounded-full ${
                    i === currentSlide ? "bg-white" : "bg-gray-300"
                  }`}
                />
              ))}
            </div>
            <button
              onClick={prevSlide}
              className="absolute right-18 bottom-2 transform -translate-y-1/2 bg-white bg-opacity-50 rounded-full p-2 hover:bg-opacity-75"
            >
              <ChevronLeft size={24} />
            </button>
            <button
              onClick={nextSlide}
              className="absolute right-4 bottom-2 transform -translate-y-1/2 bg-white bg-opacity-50 rounded-full p-2 hover:bg-opacity-75"
            >
              <ChevronRight size={24} />
            </button>
          </div>
        </div>
      </main>
      <Home2 />
      <Home3 />
      {/* <Home4 />
      <Home5 /> */}
    </div>
  );
};

export default Home;
